module.exports = __webpack_public_path__ + "img/organization-chart.297b7641.jpg";